import { User } from "@/v2/types";

function ignoreFields(
    user: User | null,
    requestedPermission: {
        module: string;
        column: string;
    },
) {
    if (!user) {
        return false;
    }

    if (user.is_admin || user?.roles?.some((role: any) => role.is_admin)) {
        return false;
    }

    if (user?.roles) {
        for (const role of user.roles) {
            if (role?.module_permissions) {
                for (const permission of role.module_permissions) {
                    if (requestedPermission.module !== permission.module.handle)
                        continue;

                    if (
                        permission.ignored_fields.includes(
                            requestedPermission.column,
                        )
                    ) {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

export default ignoreFields;
